import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  token: null,
  pToken:null,
  user: null,
  error: null,
  loading: false,
  pError: null,
  pLoading: false,
  authRedirectPath: '/auth',
  isDummy:false
};

const authStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true
  });
};

const pinxtStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true
  });
};

const authSuccess = (state, action) => {

  return updateObject(state, {
    token: action.token,
    error: null,
    loading: false
  });
};
const pinxtSuccess = (state, action) => {

  return updateObject(state, {
    pToken: action.pToken,
    pError: null,
    pLoading: false
  });
};


const authFail = (state, action) => {

  return updateObject(state, {
    error: action.error,
    loading: false
  });
};

const pinxtFail = (state, action) => {
  return updateObject(state, {
    pError: action.error,
    pLoading: false
  });
};

const authLogout = (state, action) => {
  return updateObject(state, {
    token: null,
    user: null
  });
};


const setAuthRedirectPath = (state, action) => {
  return updateObject(state, {
    authRedirectPath: action.path
  })
}
const toggleIsDummy = (state, action) => {
  return updateObject(state, {
    isDummy:state.isDummy?false:true
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.SET_AUTH_REDIRECT_PATH:
      return setAuthRedirectPath(state, action);
    case actionTypes.PINXT_START:
      return pinxtStart(state, action);
    case actionTypes.PINXT_SUCCESS:
      return pinxtSuccess(state, action);
    case actionTypes.PINXT_FAIL:
      return pinxtFail(state, action);
    case actionTypes.TOGGLE_IS_DUMMY:
      return toggleIsDummy(state, action);
    default:
      return state;
  }
};

export default reducer;
